import Clear from '../images/iconsSVG/clearSky.svg'
import Clouds from '../images/iconsSVG/clouds.svg'
// import fewClouds from '../images/iconsSVG/fewClouds.svg'
import Mist from '../images/iconsSVG/mist.svg'
import Drizzle from '../images/iconsSVG/rain.svg'
import Rain from '../images/iconsSVG/showerRain.svg'
import Snow from '../images/iconsSVG/snow.svg'
import Thunderstorm from '../images/iconsSVG/thunderstorm.svg'

export default {
  Thunderstorm,
  Drizzle,
  Rain,
  Snow,
  Clear,
  Clouds,
  Mist,
  Smoke: Mist,
  Haze: Mist,
  Dust: Mist,
  Fog: Mist,
  Sand: Mist,
  Ash: Mist,
  Squall: Mist,
  Tornado: Mist,
}
